export default __webpack_public_path__ + "static/media/third-sequence.6f2132e1.svg";